import { createSlice } from '@reduxjs/toolkit';
import { updateDropdownSettingApi } from '../../../rtk-apis/clinics/updateDropdownSetting';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const updateDropdownSettingSlice = createSlice({
  name: 'updateDropdownSetting',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateDropdownSettingApi.pending, state => {
        state.loading = true;
      })
      .addCase(updateDropdownSettingApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(updateDropdownSettingApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default updateDropdownSettingSlice.reducer;
export const { clearState } = updateDropdownSettingSlice.actions;
